module.exports = __webpack_public_path__ + "Lato-HeavyItalic.46f0461b6e19880fe446.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-HeavyItalic.woff2
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-HeavyItalic.woff2
// module chunks = styles